import React from "react";
import "./AboutUs.css";
import ceoImage from "../../assets/ceo.png";
import abouticon from "../../assets/abouticon.png";
import abouticon1 from "../../assets/abouticon1.png";

import au1 from "../../assets/au1.png";
import au2 from "../../assets/au2.png";
import au3 from "../../assets/au3.png";
import au4 from "../../assets/au4.png";
import au5 from "../../assets/au5.png";
import au6 from "../../assets/au6.png";
import aboutUsGirl from "../../assets/aboutusgirl.png";
import { Helmet } from "react-helmet";

import Footer from "../Footer";

const AboutUs = () => {
  return (
    <>
    <Helmet>
  <title>About Us | Polymath-Kids -- Building Skills for Future Success</title>
  <meta name="description" content="Discover Polymath-Kids' vision to nurture youth with digital, creative, and entrepreneurial skills. Preparing kids for school, career, and beyond." />
</Helmet>
    
    <div className="about-page">
      {/* Vision Section - Gray Background */}
      <div className="about-bg-section">
        <div className="page-header" style={{ backgroundColor: "#F0F0F0" }}>
          <div className="container">
            <h1 className="custom-header-title">
            <span
  className="about-title"
>
  About Us – The Vision Behind
</span>
<br />
<span
  className="polymath-title"
>
  Polymath-Kids
</span>

            </h1>
          </div>
        </div>

        <section className="about-overview">
          <div className="container overview-container">
            {/* Left Image */}
            <div className="overview-image overview-image-left">
              <img
                src={abouticon}
                alt="About Icon Left"
                className="about-icon-left"
              />
            </div>

            {/* Center Text */}
            <div className="overview-text">
              <p className="overview-description">
                Polymath-Kids.com is an innovative educational platform
                committed to preparing future-ready youth by equipping them with
                essential 21st Century Life Skills. It focuses on developing
                Digital Literacy, Numeracy and Language Skills, Creative and
                Analytical Thinking, as well as Social and Entrepreneurial
                Skills. Designed to nurture these capabilities from an early
                age, the platform supports children in building a strong
                foundation for lifelong learning and ensures a smooth transition
                from early education to career readiness.
              </p>
            </div>

            {/* Right Image */}
            <div className="overview-image overview-image-right">
              <img
                src={abouticon1}
                alt="About Icon Right"
                className="about-icon-right"
              />
            </div>
          </div>
        </section>
      </div>

      {/* CEO Section - White Background */}
      <section className="ceo-section">
        <div className="container">
          <h2 className="section-title">
            <span className="title-primary">
              Maryam Hamad — Visionary Founder
            </span>
            <span className="title-secondary">& CEO of Polymath-Kids</span>
          </h2>

          <div className="ceo-profile">
            <div className="ceo-image">
              <img
                src={ceoImage}
                alt="CEO Maryam Hamad"
                className="ceo-photo"
              />
            </div>
            <div className="ceo-details">
              <h3 className="ceo-credentials">
                Master of Educational Technologies – Monash University,
                Australia
                <br />
                MBA – IBA, Punjab University
              </h3>
              <p className="ceo-bio">
                Maryam Hamad is a seasoned EdTech professional with significant
                experience in both Australia and Pakistan. With a deep passion
                for education, she firmly believes in the transformative power
                of technology to empower both teachers and students. Her vision
                is to equip students worldwide with critical skills that foster
                personal growth and lifelong success through the platform
                Polymath-Kids.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 21st Century Skills Section - White Background */}
      <section className="skills-section">
        <div className="container">
          <h2 className="section-title centered-title">
            <span className="skills-title-primary">Why 21st Century Life</span>
            <span className="skills-title-secondary">Skills Matter</span>
          </h2>

          <p className="section-description">
            21st Century Skills refer to a diverse set of knowledge, habits, and
            abilities that are essential for success in today's dynamic,
            technology-driven, and globally connected world. These skills go
            beyond traditional academic subjects, focusing instead on preparing
            children for real-life challenges, lifelong learning, and meaningful
            contribution to society.
          </p>

          <div className="skills-list">
            <div className="skill-item">
              <div className="skill-icon">
                <img src={au1} alt="Digital Literacy" />
              </div>
              <div className="skill-text">
                <span className="skill-title pink">Digital Literacy:</span>{" "}
                Internet use, media awareness, coding, data skills
              </div>
            </div>

            <div className="skill-item">
              <div className="skill-icon">
                <img src={au2} alt="Critical Thinking" />
              </div>
              <div className="skill-text">
                <span className="skill-title yellow">Critical Thinking:</span>{" "}
                Reasoning, analysis, problem-solving
              </div>
            </div>

            <div className="skill-item">
              <div className="skill-icon">
                <img src={au3} alt="Communication" />
              </div>
              <div className="skill-text">
                <span className="skill-title blue">Communication:</span>{" "}
                Speaking, writing, listening, teamwork
              </div>
            </div>

            <div className="skill-item">
              <div className="skill-icon">
                <img src={au4} alt="Creativity" />
              </div>
              <div className="skill-text">
                <span className="skill-title green">Creativity:</span>{" "}
                Imagination, expression, innovation
              </div>
            </div>

            <div className="skill-item">
              <div className="skill-icon">
                <img src={au5} alt="Self-Management" />
              </div>
              <div className="skill-text">
                <span className="skill-title purple">Self-Management:</span>{" "}
                Discipline, adaptability, initiative
              </div>
            </div>

            <div className="skill-item">
              <div className="skill-icon">
                <img src={au6} alt="Science & Finance" />
              </div>
              <div className="skill-text">
                <span className="skill-title pink">Science & Finance:</span>{" "}
                Scientific thinking, money sense, wellness
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Urgent Need Section - Blue Background */}
      <section className="urgent-need-section">
        <div className="container">
          <h2 className="section-title">
            <span
              style={{
                color: "#812470",
                display: "block",
                marginBottom: "10px",
              }}
            >
              The Urgent Need for Skill
            </span>
            <span style={{ color: "#CB1D5A", display: "block" }}>
              Development in Youth
            </span>
          </h2>

          <div className="urgent-need-content">
            <div className="urgent-need-text">
              <p className="urgent-need-paragraph">
                A 2022 report by the Education Commission and UNICEF revealed
                that 3 in 4 youth globally lack essential skills for employment,
                exposing serious gaps in traditional education—especially in
                low-income countries where modern, real-world learning is often
                missing
              </p>
              <p className="urgent-need-paragraph">
                In Pakistan, the situation is worse:{" "}
                <strong>87.8% of youth</strong> fail basic literacy and numeracy
                standards, and the country ranks 125th out of 130 on the World
                Economic Forum's Education Index. These figures highlight the
                urgent need for platforms like Polymath-Kids.com, which focus on
                skill-based, future-ready learning.
              </p>
            </div>
            <div className="urgent-need-image">
              <img
                src={aboutUsGirl}
                alt="Young student learning"
                className="need-photo"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Bridge the Gap Section - White Background */}
      <section className="bridge-gap-section">
        <div className="container">
        <h2
          className="section-title gap-title responsive-heading"
          style={{ textAlign: "center", marginLeft: "150px" }}
        >
          <span style={{ color: "#812470", display: "block" }}>
            How Polymath-Kids Bridges the Gap
          </span>
          <span style={{ color: "#CB1D5A", display: "block" }}>
            with Future-Ready Skills
          </span>
        </h2>



          <p className="bridge-description">
            Polymath-Kids.com equips children with real-world skills often
            missing in traditional education. Through interactive, skill-based
            learning, kids develop digital literacy, critical thinking,
            communication, and creativity from an early age essential tools for
            the modern world.
          </p>
          <p className="bridge-description">
            Our engaging lessons and hands-on activities connect learning to
            everyday life, helping children grow into confident, future-ready
            individuals. With Polymath-Kids.com, education goes beyond the
            classroom to prepare kids for school, career, and beyond.
          </p>
        </div>
      </section>

      <Footer />
    </div>
    </>
  );
};

export default AboutUs;
